// extracted by mini-css-extract-plugin
module.exports = {"heading":"SimilarListings_heading__a4G5l","subTitle":"SimilarListings_subTitle__AG0jm","description":"SimilarListings_description__aeHBq"};